/**
 * Funcione de transformacion para inputs
 */
export function entre0Y100(value: number | undefined){
    console.log(`transform entre0Y100 ${value}`);
    let retorno = value!=undefined?value:0;
    retorno = retorno>=0?retorno:0;
    retorno = retorno<=100?retorno:100;
    console.log(`Retornando ${retorno}`);
    return retorno;
  }